// // FeedbackPage.js
// import React, { useState } from 'react';
// import axios from 'axios';

// const FeedbackPage = () => {
//   const [rating, setRating] = useState(5);
//   const [formData, setFormData] = useState({
//     fullName: '',
//     contactNumber: '',
//     feedbackMessage: '',
//     selectedOptions: [],
//   });

//   const handleInputChange = (e) => {
//     const { id, value } = e.target;
//     setFormData({ ...formData, [id]: value });
//   };

//   const handleCheckboxChange = (e) => {
//     const { value } = e.target;
//     setFormData((prevData) => {
//       const alreadySelected = prevData.selectedOptions.includes(value);
//       const updatedOptions = alreadySelected
//         ? prevData.selectedOptions.filter((item) => item !== value)
//         : [...prevData.selectedOptions, value];

//       return { ...prevData, selectedOptions: updatedOptions };
//     });
//   };

//   const handleStarClick = (value) => {
//     setRating(value);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const feedbackData = { ...formData, rating };

//     try {
//       const response = await axios.post('http://localhost:5006/api/feedback', feedbackData);
//       alert(response.data.message);
//       setFormData({
//         fullName: '',
//         contactNumber: '',
//         feedbackMessage: '',
//         selectedOptions: [],
//       });
//       setRating(5);
//     } catch (error) {
//       console.error(error);
//       alert('Failed to submit feedback.');
//     }
//   };

//   return (
//     <section className="feedback-page">
//       <div className="feedback-container">

//         {/* <div className="logo">
//           <img src="/images/Frame 38.png" alt="aman-chikan" />
//         </div> */}

//         <h2 className="popup-title">We Value Your Feedback</h2>
//         <p className="popup-subtitle">Please rate your experience below</p>

//         <form id="feedbackForm" onSubmit={handleSubmit}>
//           <div className="form-group">
//             <label htmlFor="fullName">Full Name</label>
//             <input
//               type="text"
//               id="fullName"
//               value={formData.fullName}
//               placeholder="Full name"
//               onChange={handleInputChange}
//               required
//             />
//           </div>

//           <div className="form-group">
//             <label htmlFor="contactNumber">Contact Number</label>
//             <input
//               type="tel"
//               id="contactNumber"
//               value={formData.contactNumber}
//               placeholder="+91 XXXXXXXXX"
//               onChange={handleInputChange}
//               required
//             />
//           </div>

//           <div className="form-group">
//             <label>What do you love about us</label>
//             <div className="checkbox-group">
//               {[
//                 "Overall Service",
//                 "Friendly and polite staff",
//                 "Easy to locate",
//                 "Great product variety",
//                 "Stylish setup",
//                 "Clean store",
//                 "Other",
//               ].map((item, index) => {
//                 const value = item.toLowerCase().replace(/ /g, '-');
//                 return (
//                   <label key={index}>
//                     <input
//                       type="checkbox"
//                       value={value}
//                       checked={formData.selectedOptions.includes(value)}
//                       onChange={handleCheckboxChange}
//                     />
//                     {item}
//                   </label>
//                 );
//               })}
//             </div>
//           </div>

//           <div className="form-group">
//             <label htmlFor="feedbackMessage">Feedback Message</label>
//             <textarea
//               id="feedbackMessage"
//               value={formData.feedbackMessage}
//               placeholder="Tell us about your experience"
//               onChange={handleInputChange}
//             ></textarea>
//           </div>

//           <div className="rating-container">
//             <div className="rating-stars">
//               {[1, 2, 3, 4, 5].map((star) => (
//                 <span
//                   key={star}
//                   className={`star ${star <= rating ? 'active' : ''}`}
//                   onClick={() => handleStarClick(star)}
//                 >
//                   ★
//                 </span>
//               ))}
//             </div>
//             <div className="rating-text">{rating}/5 stars</div>
//           </div>

//           <button type="submit" className="submit-btn">Submit</button>
//         </form>
//       </div>
//     </section>
//   );
// };

// export default FeedbackPage;




import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

const FeedbackPage = () => {
  const [rating, setRating] = useState(5);

  const [formData, setFormData] = useState({
    fullName: '',
    contactNumber: '',
    feedbackMessage: '',
    selectedOptions: [],
    bot_field: '' //  spam protection
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [toast, setToast] = useState({
    show: false,
    type: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleCheckboxChange = (e) => {
    const { value } = e.target;

    setFormData((prevData) => {
      const alreadySelected = prevData.selectedOptions.includes(value);

      const updatedOptions = alreadySelected
        ? prevData.selectedOptions.filter((item) => item !== value)
        : [...prevData.selectedOptions, value];

      return { ...prevData, selectedOptions: updatedOptions };
    });
  };

  const handleStarClick = (value) => {
    setRating(value);
  };

  // 🚀 UPDATED SUBMIT FUNCTION
  const handleSubmit = (e) => {
    e.preventDefault();

    // 🛡️ Spam protection
    if (formData.bot_field) {
      console.log('Bot detected');
      return;
    }

    setIsSubmitting(true);

    const feedbackData = {
      ...formData,
      rating,
      selectedOptions: formData.selectedOptions.join(', ')
    };

    emailjs.send(
      'service_8cx719a',
      'template_2qkrqpr',
      feedbackData,
      'x6LsTRWcFM6DUKZpv'
    )
    .then(() => {
      setToast({
        show: true,
        type: 'success',
        message: '✅ Feedback submitted successfully!'
      });

      setFormData({
        fullName: '',
        contactNumber: '',
        feedbackMessage: '',
        selectedOptions: [],
        bot_field: ''
      });

      setRating(5);
    })
    .catch(() => {
      setToast({
        show: true,
        type: 'error',
        message: '❌ Failed to submit feedback'
      });
    })
    .finally(() => {
      setIsSubmitting(false);

      setTimeout(() => {
        setToast({ show: false, type: '', message: '' });
      }, 3000);
    });
  };

  return (
    <section className="feedback-page">
      <div className="feedback-container">

        {/* 🔥 TOAST MESSAGE */}
        {toast.show && (
          <div className={`toast ${toast.type}`}>
            {toast.message}
          </div>
        )}

        <h2 className="popup-title">We Value Your Feedback</h2>
        <p className="popup-subtitle">Please rate your experience below</p>

        <form id="feedbackForm" onSubmit={handleSubmit}>

          {/* 🛡️ Honeypot Field */}
          <input
            type="text"
            name="bot_field"
            value={formData.bot_field}
            onChange={(e) =>
              setFormData({ ...formData, bot_field: e.target.value })
            }
            style={{ display: 'none' }}
          />

          <div className="form-group">
            <label htmlFor="fullName">Full Name</label>
            <input
              type="text"
              id="fullName"
              value={formData.fullName}
              placeholder="Full name"
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="contactNumber">Contact Number</label>
            <input
              type="tel"
              id="contactNumber"
              value={formData.contactNumber}
              placeholder="+91 XXXXXXXXX"
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label>What do you love about us</label>
            <div className="checkbox-group">
              {[
                "Overall Service",
                "Friendly and polite staff",
                "Easy to locate",
                "Great product variety",
                "Stylish setup",
                "Clean store",
                "Other",
              ].map((item, index) => {
                const value = item.toLowerCase().replace(/ /g, '-');

                return (
                  <label key={index}>
                    <input
                      type="checkbox"
                      value={value}
                      checked={formData.selectedOptions.includes(value)}
                      onChange={handleCheckboxChange}
                    />
                    {item}
                  </label>
                );
              })}
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="feedbackMessage">Feedback Message</label>
            <textarea
              id="feedbackMessage"
              value={formData.feedbackMessage}
              placeholder="Tell us about your experience"
              onChange={handleInputChange}
            ></textarea>
          </div>

          <div className="rating-container">
            <div className="rating-stars">
              {[1, 2, 3, 4, 5].map((star) => (
                <span
                  key={star}
                  className={`star ${star <= rating ? 'active' : ''}`}
                  onClick={() => handleStarClick(star)}
                >
                  ★
                </span>
              ))}
            </div>
            <div className="rating-text">{rating}/5 stars</div>
          </div>

          {/* 🚀 BUTTON WITH LOADER */}
          <button
            type="submit"
            className="submit-btn"
            disabled={isSubmitting}
          >
            {isSubmitting ? <span className="loader"></span> : 'Submit'}
          </button>

        </form>
      </div>
    </section>
  );
};

export default FeedbackPage;
